import React from 'react'
import {observer} from 'mobx-react'

import {formatAccountNumberWithDots} from './services'
import {AccountNumberViewProps} from './props'
import styles from './AccountNumberView.scss'
import { BANK_ACCOUNT_NUMBER, BANK_ACCOUNT_NUMBER_MASK } from '@/constants/playwright-ids'

export const AccountNumberView: React.FC<AccountNumberViewProps> = observer(({accountNumber}) => {
    if (!accountNumber) return null

    const {firstPart, secondPart} = formatAccountNumberWithDots(accountNumber?.split(' ')[0])

    return (
        <div className={styles.maskedNumber} data-test-id={BANK_ACCOUNT_NUMBER}>
            <span className={styles.dots} data-test-id={BANK_ACCOUNT_NUMBER_MASK}></span> <span>{firstPart}&nbsp;</span>{' '}
            <span>{secondPart}</span>
        </div>
    )
})
